import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "discount", "custom"]

  connect() {
    this.boundOnChange = this.onChange.bind(this)
    this.element.addEventListener("change", this.boundOnChange)
    customElements.whenDefined("el-select").then(() => this.toggleAll())
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundOnChange)
  }

  onChange(event) {
    if (event.target.matches("el-select[name*='[kind]'], select[name*='[kind]']")) this.toggleAll()
  }

  toggleAll() {
    this.element.querySelectorAll("[data-nested-form-target='row']").forEach(row => {
      const select = row.querySelector("el-select[name*='[kind]'], select[name*='[kind]']")
      const kind = select?.value
      row.querySelectorAll("[data-product-kind-target='quantity']").forEach(el => { el.hidden = kind !== "limited" })
      row.querySelectorAll("[data-product-kind-target='discount']").forEach(el => { el.hidden = kind !== "discounted" })
      row.querySelectorAll("[data-product-kind-target='custom']").forEach(el => { el.hidden = kind !== "custom" })
    })
  }
}
